export let items = [
  { nombre: "Pantalón", id: 1, empacado: false },
  { nombre: "Chaqueta", id: 2, empacado: false },
  { nombre: "Cargador de teléfono", id: 3, empacado: false },
  { nombre: "MacBook", id: 4, empacado: false },
  { nombre: "Ropa interior", id: 5, empacado: false },
  { nombre: "Sombrero", id: 6, empacado: false },
  { nombre: "Cinturón", id: 7, empacado: false },
  { nombre: "Pastillas", id: 8, empacado: false },
  { nombre: "Pasaporte", id: 9, empacado: false },
  { nombre: "Sandwich", id: 10, empacado: false }
];
